import * as React from 'react';
import { SVGProps } from 'react';

const IconDownSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M6.79 10.382 3.491 7.085 2.078 8.499l5.711 5.711 5.712-5.71-1.415-1.415-3.297 3.297V1.789h-2v8.593Z" />
  </svg>
);
export default IconDownSizeS;
